module.exports = __webpack_public_path__ + "static/media/chat_mobile.91a04e3b.svg";